<button mat-dialog-title mat-mini-fab color="primary" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  @if(data.safetyCheckQuestionData) { <h1>{{ data.safetyCheckQuestionData.Name | translate }}</h1> }
  @else { <h1>{{'T4.Settings.SafetyCheckQuestionDialog.createSafetyCheckQuestionTitle' | translate:'Create Safety Check Question' }}</h1> }
  <t4-container>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Turbo.Settings.SafetyCheckQuestionDialog.lblKey' | translate : 'Key' }}</mat-label>
      <input matInput [(ngModel)]="safetyCheckQusetions.Key" autocomplete="off" required (blur)="onKeyBlur()">
    </mat-form-field>
    @if(translationKey)
    {
    <div *ngIf="isLoading" class="loader">Loading...</div>
    <ng-container>
      <div class="row">
        <div class="col-2 d-flex align-items-center">{{ 'Turbo.Settings.SafetyCheckQuestionDialog.lblName' | translate : 'Name' }}</div>
        <div class="col-10">
          <t4-translation-editor [translationKey]="translationKey"></t4-translation-editor>
        </div>
      </div>
    </ng-container>
    }
    <label style="margin-top: 10px">{{ 'Turbo.Settings.SafetyCheckQuestionDialog.lblSortOrder' | translate : 'Sort Order' }}: </label><br />
    <mat-slider min="0" max="100" step="1" discrete style="margin-top: 10px;">
      <input matSliderThumb [(ngModel)]="safetyCheckQusetions.SortOrder" />
    </mat-slider>
  </t4-container>

</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end">
  <button mat-raised-button color="primary" style="margin: 5px;" (click)="save()">{{ 'Turbo.Settings.SafetyCheckQuestionDialog.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.SafetyCheckQuestionDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
